module.exports = __webpack_public_path__ + "img/css.693365cf.svg";